import { VitrineOfferInterface } from '../../models/vitrine-offer.interface';

export interface ChangeOffersEligibleListInterfaceState {
  response: Array<VitrineOfferInterface>;
}

export const initialChangeOffersEligibleListState: ChangeOffersEligibleListInterfaceState = {
  response: null
};
